import { SortDirectionType, SortingOptionsType } from '@components/design/migrated/Table';
import { ReactElement } from 'react';
import { ColumnHeaderForCL } from '@models/CategoryLeaderboard';

export enum GrowthTypes {
  actual = 'actual',
  percentage = 'percentage',
}

export interface KpiDropdownOption {
  label: string | ReactElement | Element;
  value: ColumnHeaderForCL;
}

export const defaultSortingOptions: SortingOptionsType = {
  headerKey: ColumnHeaderForCL.yourRevenue,
  sortKey: '',
  sortDir: SortDirectionType.desc,
  label: 'Absolute',
};

export enum SortKeys {
  Absolute = '',
  Change = 'Change',
}

export enum SortLabels {
  Absolute = 'Absolute',
  Change = 'Change',
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export interface SortingDropdownOption {
  label: string;
  value: string;
}

export const SegmentationChart = 'segmentation-chart';

export const sortFields = [
  {
    sortKey: SortKeys.Absolute,
    label: SortLabels.Absolute,
    sortDirection: SortDirectionType.asc,
  },
  {
    sortKey: SortKeys.Absolute,
    label: SortLabels.Absolute,
    sortDirection: SortDirectionType.desc,
  },
  {
    sortKey: SortKeys.Change,
    label: SortLabels.Change,
    sortDirection: SortDirectionType.asc,
  },
  {
    sortKey: SortKeys.Change,
    label: SortLabels.Change,
    sortDirection: SortDirectionType.desc,
  },
];
